import PageBanner from "../components/PageBanner";
import { partners } from "../data/site";

export default function Partners() {
  return (
    <div className="inner-page">
      <PageBanner title="合作伙伴" en="PARTNERS" variant="partner" />
      <section className="panel">
        <div className="container">
          <h2 className="small-title">合作伙伴</h2>
          <p className="panel-lead">
            依托母公司文趣星球及开普云、博瑞传播的产业网络，文趣互动与科技、传媒、文旅、教育等领域伙伴协同，共建文化元宇宙生态。
          </p>
          <div className="logo-wall partner-page-wall">
            {partners.map((p) => (
              <div className="logo-chip large" key={p.name}>
                <strong>{p.name}</strong>
                <small>{p.en}</small>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
